import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ApiClient } from "@topline/services/apiService";

(function (module) {
    "use strict";

    module.service("forecastApprovalService", ['$uibModal', '$q', 'forecastProcessService', ApiClient.componentName, 'AlertService', angularServicesNames.$translate, forecastApprovalService]);

    function forecastApprovalService(
        this: $TSFixMe,
        $uibModal: ng.ui.bootstrap.IModalService,
        $q: ng.IQService,
        forecastProcessService: $TSFixMe,
        apiClient: ApiClient,
        AlertService: AlertService,
        $translate: ng.translate.ITranslateService
    ) {
        var service = this;

        service.sendToApproval = (forecastId: $TSFixMe, forecastStartDate: Date) => {

            return apiClient.getBudgetVersionsForDate(forecastStartDate).then((versions) => {
                const defer = $q.defer();

                const allowedVersions = _.filter(versions, (v: $TSFixMe) => v.isEditable);

                if (allowedVersions.length == 1) {
                    
                    sendToApproval(forecastId, _.head(allowedVersions), defer);
                } else if (allowedVersions.length == 0) {
                    AlertService.error($translate.instant('NO_EDITABLE_BUDGET_VERSION'));
                    defer.resolve();
                    return defer.promise;
                } else {
                    const modalInstance = $uibModal.open({
                        component: 'chooseBudgetVersion',
                        resolve: {
                            versions: () => allowedVersions
                        }
                    });
                    modalInstance.result.then((version) => {
                        sendToApproval(forecastId, version, defer);
                    }, () => defer.resolve());
                }
                return defer.promise;
            });
        }

        service.sendToApprovalInVersion = (forecastId: $TSFixMe, version: $TSFixMe) => {
            const defer = $q.defer();
            sendToApproval(forecastId, version, defer);
            return  defer.promise;           
        }

        function sendToApproval(forecastId: $TSFixMe, version: $TSFixMe, defer: $TSFixMe) {
            forecastProcessService.sendToApproval(forecastId, version.versionId).then((response: $TSFixMe) => {
                if (response.status == HttpStatus.OK || response.status == 204) {
                    defer.resolve();
                } else {
                    errorHandler(response, forecastId, version.versionId, defer, true);
                }
            });
        }

        service.approve = (forecastId: $TSFixMe) => {
            const defer = $q.defer();
            forecastProcessService.approve(forecastId).then((response: $TSFixMe) => {
                if (response.status == HttpStatus.OK || response.status == 204) {
                    defer.resolve();
                } else {
                    errorHandler(response, forecastId, null, defer, false);
                }
            });
            return defer.promise;
        }

        service.approveCorrectionAfterDefence = (forecastId: $TSFixMe) => {
            const defer = $q.defer();
            forecastProcessService.approveCorrectionAfterDefence(forecastId).then((response: $TSFixMe) => {
                if (response.status == HttpStatus.OK || response.status == 204) {
                    defer.resolve();
                } else {
                    // @ts-expect-error ts-migrate(2554) FIXME: Expected 5 arguments, but got 4.
                    errorHandler(response, forecastId, defer, false);
                }
            });
            return defer.promise;
        }

        service.showApproveValidationErrors = (data: $TSFixMe) => {
            const modalInstance = $uibModal.open({
                component: 'forecastSendToApprovalForce',
                resolve: {
                    errors: () => data.validationErrors,
                    market: () => data.notFinishedMarket,
                    allowForece: () => false
                }
            });
            modalInstance.result.then(() => {}, () => {});
        }

        const errorHandler = (err: $TSFixMe, context: $TSFixMe, versionId: $TSFixMe, defer: $TSFixMe, allowForece: $TSFixMe) => {
            switch (err.status) {
                case HttpStatus.NotAcceptable:
                    AlertService.error($translate.instant('FORECAST_EDIT_LOCKED'));
                    defer.reject();
                    break;
                case HttpStatus.Conflict:
                    forecastWithGivenOracleIndexAlreadyExistOrNotFinishedMarketErrorHandler(err.data, context, versionId, defer, allowForece);
                    break;
                case HttpStatus.PreconditionFailed:
                    AlertService.error($translate.instant('NO_GM_IN_PANDL'));
                    defer.reject();
                    break;
                default:
                    defer.reject();
                    break;
            }
        };

        const forecastWithGivenOracleIndexAlreadyExistOrNotFinishedMarketErrorHandler = (data: $TSFixMe, forecastId: $TSFixMe, versionId: $TSFixMe, defer: $TSFixMe, allowForece: $TSFixMe) => {
            const modalInstance = $uibModal.open({
                component: 'forecastSendToApprovalForce',
                resolve: {
                    errors: () => data.validationErrors,
                    market: () => data.notFinishedMarket,
                    allowForece: () => allowForece
                }
            });
            modalInstance.result.then(() => {
                forecastProcessService.sendToApproval(forecastId, versionId, true)
                    .then(() => defer.resolve(), () => defer.reject());
            }, () => defer.reject());
        };
    }


})(angular.module('topline.services'));